import { LockSimple, Question, WarningCircle, type Icon } from '@phosphor-icons/react';
import { Badge } from '../../../components/ui/badge';
import { cn } from '../../../lib/utils';
import type { CreatorLookupPill, CreatorLookupTone } from './creatorLookupStatus';

// Compact soft pill sized to sit under the handle without crowding the row.
const LOOKUP_BADGE_BASE_CLASS =
  'px-1.5 py-px text-[10px] font-medium uppercase leading-4 tracking-wide [&>svg]:size-2.5';

// Private is amber (the account exists — contact the creator); not found keeps
// the roster's red "Rejected" tone. The icon carries the difference too, so it
// never rests on colour alone. Couldn't-check is neutral slate: it is an
// unknown, not a verdict on the creator.
const TONE_CLASS: Record<CreatorLookupTone, string> = {
  private: 'bg-amber-100 text-amber-800',
  missing: 'bg-red-100 text-red-700',
  unchecked: 'bg-slate-100 text-slate-700',
};

const TONE_ICON: Record<CreatorLookupTone, Icon> = {
  private: LockSimple,
  missing: WarningCircle,
  unchecked: Question,
};

/** PRIVATE / NOT FOUND / COULDN'T CHECK pill under the creator's handle. */
export function CreatorLookupBadge({ pill }: { pill: CreatorLookupPill | null }) {
  if (!pill) return null;
  const ToneIcon = TONE_ICON[pill.tone];
  return (
    <Badge variant="secondary" data-tone={pill.tone} className={cn(LOOKUP_BADGE_BASE_CLASS, TONE_CLASS[pill.tone])}>
      <ToneIcon weight="bold" aria-hidden />
      {pill.label}
    </Badge>
  );
}
